var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tab', { active: _vm.active }, _vm.customClass],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }